module.exports = __webpack_public_path__ + "01fd3d490539ae10f5bb2da5ad3c605d.jpg";